import React, {useEffect, useState} from 'react';
import QuestionDisplay from "../../common/QuestionDisplay";
import AnswerSelect from "../../common/AnswerSelect";
import QuestionCommentSection from "../../common/QuestionCommentSection";
import {withStyles} from "@material-ui/core/styles";

const styles = {
  answersBox:{position:"relative", height: "7.5rem", width: "100%"},
  answer:{position:"absolute", width: "100%"},
}
function SingleQuestionPage(props) {
  const { classes, ...passProps } = props;
  const { surveyAttempt, submitAnswer, questionIndex, setQuestionIndex} = props;
  const survey = surveyAttempt.survey;
  const options = survey.options.choices[0];

  const question = surveyAttempt.survey.questions[questionIndex] || {};
  const {id:questionId, subtitle, statement} = question;

  // eslint-disable-next-line no-unused-vars
  const [answerId, [ansChoice = null]=[], answerDate, ansComment="", commentDate=null] = (surveyAttempt.answers[questionIndex] || []);

  const [comment, setComment] = useState(ansComment);
  const [slide, setSlide] = useState(true);
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(null);

  useEffect(() => {
    setSlide(true);
    // const answer = surveyAttempt.answers[questionIndex] || [];
    setComment(ansComment || "");
    setEditing(ansChoice !== null);
    resetPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionIndex])

  const resetPage = () => {
    // setCommentOpen(false);
  };

  const nextQuestion = (answerChoice, callback=()=>{}) => {
    if(answerChoice === ansChoice && comment === ansComment){
      setSlide(false);
      setTimeout(() => {
        setQuestionIndex(Math.min(survey.questions.length, questionIndex + 1))
        callback();
      }, 250);
    } else {
      if(!submitAnswer(questionId, [answerChoice], answerDate, comment, commentDate, () => {
        setSlide(false);
        setTimeout(() => {
          setQuestionIndex(Math.min(survey.questions.length, questionIndex + 1))
          callback();
        }, 250)
      })){
        callback();
      }
    }
  };

  return (
    <>
      <QuestionDisplay
        subtitle={subtitle}
        statement={statement}
        slide={slide}
      />
      <div id={"questionAnswers"} className={classes.answersBox}>
        <div id={"answerMenu"} className={classes.answer}>
          <AnswerSelect
            key={`ans${questionId}`}
            slideIn={slide && !editing}
            slideDirection={editing ? null : slide ? "right" : "left"}
            question={options.instructions}
            colorClass={options.color_class}
            answerOpts={options.answers}
            labelMin={<>{options.answers[0].label}</>}
            labelMid={<>{options.answers[Math.floor(options.answers.length/2)].label}</>}
            labelMax={<>{options.answers[options.answers.length-1].label}</>}
            value={ansChoice}
            setVal={val => {
              if (saving !== null) {
                return
              }
              setSaving([0, val]);
              nextQuestion(val, () => {
                setSaving(null)
              })
            }}
            saving={!saving ? null : saving?.[0] === 0 ? [saving[1]] : [null]}
          />
        </div>
      </div>
      <QuestionCommentSection {...passProps} />
    </>
  )
}

export default withStyles(styles)(SingleQuestionPage);